import React, { useEffect } from 'react';
import useRouteHandle from '../useRouteHandle';
import PageLayout from './PageLayout';
import DesktopAppFeatures from '../../desktop/DesktopAppFeatures';
import ExpandedPostModal from '../../post/modalView/ExpandedPostModal';
import { UIActions } from '../../ui/uiSlice';
import { isElectron } from '../../utils/desktopClient';
import { useAppDispatch } from '../redux/useAppSelector';

const useExtensionFeatures = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const listener = (event: Event) => {
      const { id } = (event as CustomEvent<{ id: string }>).detail;
      dispatch(UIActions.openModal(ExpandedPostModal, { initialId: id }));
    };

    document.addEventListener(
      'slab-extension.postModalContextMenuClicked',
      listener,
    );
    return () => {
      document.removeEventListener(
        'slab-extension.postModalContextMenuClicked',
        listener,
      );
    };
  }, [dispatch]);
};

const InternalApp = () => {
  const { routeName, pageLayout = {} } = useRouteHandle();

  useExtensionFeatures();

  return (
    <>
      {isElectron && <DesktopAppFeatures />}
      <PageLayout.Root elements={pageLayout} routeName={routeName} />
    </>
  );
};

export default InternalApp;
